import cpt_chart_candlestick_option from '@/components/echarts/attrs/cpt-chart-candlestick-option'
let option = JSON.parse(JSON.stringify(cpt_chart_candlestick_option))
option.cptDataForm.dataText = JSON.stringify([
    {
        group:'日k',
        data:[
            {name:"10-08",value: [20, 34, 10, 38]},
            {name:"10-09",value: [40, 35, 30, 50]},
            {name:"10-10",value: [30, 45, 20, 50]},
            {name:"10-11",value: [10, 25, 5, 30]},
            {name:"10-12",value: [35, 22, 10, 20]},
            {name:"10-13",value: [20, 34, 10, 38]},
        ]
    },
    {
        group:'沪深300',
        type: 'line',
        data:[
            {name:'10-08',value:34},
            {name:'10-09',value:35},
            {name:'10-10',value:45},
            {name:'10-11',value:25},
            {name:'10-12',value:22},
            {name:'10-13',value:34},
        ]
    },
    {
        group:'上证50',
        type: 'line',
        data:[
            {name:'10-08',value:30},
            {name:'10-09',value:31},
            {name:'10-10',value:41},
            {name:'10-11',value:22},
            {name:'10-12',value:26},
            {name:'10-13',value:37},
        ]
    },
    {
        group:'中证500',
        type: 'line',
        data:[
            {name:'10-08',value:25},
            {name:'10-09',value:34},
            {name:'10-10',value:42},
            {name:'10-11',value:31},
            {name:'10-12',value:24},
            {name:'10-13',value:31},
        ]
    },
])
option.attribute.cptTableData = [
    { "name": "分组", "value": "", "namekey": "group" },
    { "name": "类型", "value": "", "namekey": "type" },
    { "name": "维度", "value": "", "namekey": "name" },
    { "name": "指标", "value": "", "namekey": "value" },
]
export default option